<div class="viewer-container">
  @if (errorMessage()) {
    <div class="error-message">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" x2="12" y1="8" y2="12" />
        <line x1="12" x2="12.01" y1="16" y2="16" />
      </svg>
      {{ errorMessage() }}
    </div>
  }

  <div #svgContainer class="svg-container" [class.hidden]="!!errorMessage()"></div>


  @if (isProcessing()) {
    <div class="processing-indicator">Processing...</div>
  }
</div>